// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-ProofOfAddress-Guidance-absolute-center","content":"onfido-sdk-ui-ProofOfAddress-Guidance-content","subTitle":"onfido-sdk-ui-ProofOfAddress-Guidance-subTitle","bolder":"onfido-sdk-ui-ProofOfAddress-Guidance-bolder","makeSure":"onfido-sdk-ui-ProofOfAddress-Guidance-makeSure","docImageContainer":"onfido-sdk-ui-ProofOfAddress-Guidance-docImageContainer","docImage":"onfido-sdk-ui-ProofOfAddress-Guidance-docImage","label":"onfido-sdk-ui-ProofOfAddress-Guidance-label"};


//////////////////
// WEBPACK FOOTER
// ./components/ProofOfAddress/Guidance/style.css
// module id = 138
// module chunks = 1